// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginBtn_wrapper__U8Tyi"};